import React, { useCallback, ComponentProps } from 'react'
import { useRouter } from 'next/router'
import { paths } from 'src/utils/paths'
import { useDeleteItandiAccountSessions } from '@hooks/useItandiAccountSessions'
import { useDeleteItandiAccountUserSessions } from '@hooks/useItandiAccountUserSessions'
import { useAccounts } from '@hooks/useAccounts'
import { ItandiHeader } from '@itandi/brand-ui/ItandiHeader'
import { DeepReadonly } from '@itandi/itandi-bb-ui'
import Link from 'next/link'
import { ItandiAccounUsertSession } from '../models/ItandiAccountUserSession'
import { ItandiAccountSession } from '../models/ItandiAccountSession'

type Props = DeepReadonly<{
  account: ItandiAccountSession
  user: ItandiAccounUsertSession
}>

export const Header: React.FC<Props> = ({ account, user }) => {
  const router = useRouter()
  const { data: stores } = useAccounts()
  const isActivePage = useCallback(
    (path: string): boolean =>
      path === '/' ? router.pathname === '/' : router.pathname.includes(path),
    [router.pathname]
  )

  const deleteItandiAccountSessions = useDeleteItandiAccountSessions()
  const deleteItandiAccountUserSessions = useDeleteItandiAccountUserSessions()

  const handleLogout = async () => {
    await deleteItandiAccountSessions.mutateAsync()
    router.push(`/contracts`)
  }
  const handleLogoutStaff = async () => {
    await deleteItandiAccountUserSessions.mutateAsync()
    router.push(`/contracts`)
  }
  const filteredAccounts = stores
    ? stores.map((store) => ({
        authId: store.authId,
        name: store.name,
      }))
    : []

  const itandiHeaderV3Menus: ComponentProps<typeof ItandiHeader>['menus'] = [
    {
      label: '案件一覧',
      kind: 'link',
      as: Link,
      href: paths.inspectionList,
      active: isActivePage(paths.inspectionList),
    },
    {
      label: '建物管理契約',
      kind: 'link',
      as: Link,
      href: paths.contractList,
      active: isActivePage(paths.contractList),
    },
    {
      label: '取引先',
      kind: 'link',
      as: Link,
      href: paths.vendorList,
      active: isActivePage(paths.vendorList),
    },
    {
      label: '設定',
      kind: 'list',
      active:
        isActivePage(paths.roleList) || isActivePage(paths.todoTemplateList),
      items: [
        {
          label: '担当者とロール',
          as: Link,
          href: paths.roleList,
        },
        {
          label: 'TODOテンプレート',
          as: Link,
          href: paths.todoTemplateList,
        },
      ],
    },
  ]

  return (
    <ItandiHeader
      changeableStores={filteredAccounts}
      changeStaff={handleLogoutStaff}
      itandiAccount={{
        companyName: `${account.companyName}`,
        storeName: `${account.storeName}`,
      }}
      logout={handleLogout}
      menus={itandiHeaderV3Menus}
      productCode='tk'
      productMenus={account.productParams}
      staffAccount={user}
    />
  )
}
